import { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import BG from './res/BG.jpg';
import nftVid from './res/nftComp.mp4';

import './App.css';

import { ethers } from 'ethers';

// Web pages
const RPCURL = "https://rpc.ftm.tools/";
const NETWORK = 250;

const lockerAddress = '0x6a9AF6F3f6B0f8DF4C0B23BA060839AD4033f98a';
const lockerABI = require('./lockerABI.json');

const NFTAddress = "0x400cD9E74AFdfc05388cb149E8FEc2B112AfeF3E";
const NFTABI = require('./nftABI.json');

const tokenID = 0;

function App() {

	const [currentAccount, setCurrentAccount] = useState();
	const [wallet, setWallet] = useState(window.ethereum);
	const [provider, newProvider] = useState(new ethers.providers.Web3Provider(wallet, "any"));
	const [mintCount, setMintCount] = useState(0);
	const [NFTContract, newNFTContract] = useState(new ethers.Contract(NFTAddress, NFTABI, provider.getSigner(0)));
	const [lockContract, newLockContract] = useState(new ethers.Contract(lockerAddress, lockerABI, provider.getSigner(0)));

	const [ownedCount, setOwnedCount] = useState(0);
	const [price, setPrice] = useState(0);
	const [credits, setCredits] = useState(0);
	const [minted, setMinted] = useState(0);

	const correctChain = async () => {
		try {
			await wallet.request({
				method: 'wallet_switchEthereumChain',
				params: [{ chainId: ('0x' + NETWORK.toString(16)) }], // chainId must be in hexadecimal numbers
			});
		} catch (error) {
			// This error code indicates that the chain has not been added to MetaMask
			// if it is not, then install it into the user MetaMask
			if (error.code === 4902) {
				try {
					await wallet.request({
						method: 'wallet_addEthereumChain',
						params: [
							{
								chainId: ('0x' + NETWORK.toString(16)),
								rpcUrl: RPCURL,
							},
						],
					});
				} catch (addError) {
					console.error(addError);
				}
			}
			console.error(error);
		}
	}

	const connectWalletHandler = async () => {
		const _newAccount = await wallet.request({ method: 'eth_requestAccounts' });
		newProvider(new ethers.providers.Web3Provider(wallet, "any"));
		newNFTContract(new ethers.Contract(NFTAddress, NFTABI, provider.getSigner(0)));
		newLockContract(new ethers.Contract(lockerAddress, lockerABI, provider.getSigner(0)));
		setCurrentAccount(_newAccount[0]);

		const count = await NFTContract.balanceOf(_newAccount[0].toLowerCase(), tokenID);
		const freebies = await NFTContract._credits(_newAccount[0].toLowerCase(), tokenID);
		const p = await NFTContract._prices(tokenID);

		setOwnedCount(count.toNumber());
		setPrice(p);
		setCredits(freebies.toNumber());
	}

	const addListeners = async () => {
		provider.on('network', async (newNetwork, oldNetwork) => {
			correctChain();
		});

		wallet.on('accountsChanged', async (_newAccount, _oldAccount) => {
			setCurrentAccount(_newAccount[0]);
			const count = await NFTContract.balanceOf(_newAccount[0].toLowerCase(), tokenID);
			const freebies = await NFTContract._credits(_newAccount[0].toLowerCase(), tokenID);
			const p = await NFTContract._prices(tokenID);

			setOwnedCount(count.toNumber());
			setPrice(p);
			setCredits(freebies.toNumber());
			getCount();
		});
	}

	useEffect(() => {
		newProvider(new ethers.providers.Web3Provider(wallet, "any"));
		addListeners();
		setWallet(window.ethereum);
		getCount();
	}, [])

	const connectWalletButton = () => {
		if (currentAccount) {
			return (
				<button className='cta-button'> {currentAccount.substring(0, 6) + "..." + currentAccount.slice(-4)}</button>
			)
		} else {
			return (
				<button className='cta-button responsive' onClick={() => { correctChain(); connectWalletHandler() }}>Connect</button>
			)
		}
	}
	
		const getCount = async () => {
		let mintFilter = NFTContract.filters.TransferSingle(null,'0x0000000000000000000000000000000000000000', null,null);
		let burnFilter = NFTContract.filters.TransferSingle(null, null,'0x0000000000000000000000000000000000000000',null);
		let burnBatchFilter = NFTContract.filters.TransferBatch(null, null,'0x0000000000000000000000000000000000000000',null, null);
		mintFilter.id = tokenID;
		burnFilter.id = tokenID;
		burnBatchFilter.ids = [tokenID];
				
		let mints = await NFTContract.queryFilter(mintFilter);
		let burns = await NFTContract.queryFilter(burnFilter);	
		let batchBurns = await NFTContract.queryFilter(burnBatchFilter);
		
		let mintTally = tallyEvent(mints);
		let burnTally = tallyEvent(burns);
		let burnBatchTally = tallyEvent(batchBurns);
		
		setMinted(mintTally - burnTally - burnBatchTally);
	}
	
	const tallyEvent = (event) => {
		let tally = 0;
		for (let i = 0; i < event.length; i++){
			tally += event[i].args.value.toNumber();
		}
		return tally;
	}

	const handleCount = (incrementing) => {
		if (incrementing) {
			if (credits == 0 || mintCount < credits)
				setMintCount(mintCount + 1);
		} else if (mintCount > 0) {
			setMintCount(mintCount - 1);
		}
	}

	const amountButtons = () => {
		if (currentAccount) {
			return (
				<>
					<button className='cta-button increment responsive' onClick={() => handleCount(false)}>-</button>
					<button className='cta-display amount'>{mintCount}</button>
					<button className='cta-button increment responsive' onClick={() => handleCount(true)}>+</button>
				</>
			)
		} else {
			return (
				<>
					<button className='cta-button-disabled increment'>-</button>
					<button className='cta-button-disabled amount'>0</button>
					<button className='cta-button-disabled increment'>+</button>
				</>
			)
		}
	}

	const mintHandler = async () => {
		try {
			const total = mintCount;
			const FTMprice = ethers.utils.formatEther(price.mul(total));
			console.log(FTMprice);
			const tx = await NFTContract.mint(tokenID, total, '0x', { value: ethers.utils.parseEther(FTMprice) });
			toast.promise(
				tx.wait(),
				{
					pending: 'Transaction Pending...',
					success: 'Successfully Minted!',
					error: 'Transaction Failed...'
				}
			)
			setOwnedCount(ownedCount + total);
		} catch (e) {
			console.log(e);
		}
	}

	const freeMintHandler = async () => {
		try {
			const total = mintCount;
			const tx = await NFTContract.creditedMint(tokenID, total, '0x', { value: 0 });
			toast.promise(
				tx.wait(),
				{
					pending: 'Transaction Pending...',
					success: 'Successfully Minted!',
					error: 'Transaction Failed...'
				}
			)
			setOwnedCount(ownedCount + total);
			setCredits(credits - total);
		} catch (e) {

		}
	}



	const mintButton = () => {
		if (currentAccount && mintCount > 0) {
			if (credits == 0) {
				return (
					<button className='cta-button mint responsive' onClick={() => mintHandler()}>Mint</button>
				)
			} else {
				return (
					<button className='cta-button mint responsive' onClick={() => freeMintHandler()}>Credit Mint</button>
				)
			}
		} else {
			return (
				<button className='cta-button-disabled mint'>Mint</button>
			)
		}
	}

	const stemHandler = async () => {
		try {
			const url = await lockContract.getContentERC1155(NFTAddress.toLowerCase(), tokenID);
			window.open(url, "_blank");
		} catch (e) {
			toast.error('Download Error');
		}
	}


	const stemButton = () => {
		if (ownedCount > 0) {
			return (
				<button className='cta-button stems responsive' onClick={() => stemHandler()}>Download Track</button>
			)
		} else {
			return (
				<button className='cta-button-disabled stems'>Download Track</button>
			)
		}
	}

	return (
		<div className="App">
			<img src={BG} className="backgroundImage" alt="wallpaper" />
			<header className="App-header">
				<div>
					<div className='nftContent'>
						<video className='nftVid' playsInline controls>
							<source src={nftVid} type='video/mp4' />
						</video>
						<div className='darkerCard'>
							<div className='nftDetails'>
								<div className='nftTitle'><b>Steven Vinyl</b> - <i>8-bit Madness</i></div>
								<div className='nftDesc'>8Bit Madness is a track inspired by the game Snafu. One of my favorite riffs modified and adapted in a modern, trippy and playful style, but still staying true to that old 8bit vibe. <br /><br />Owner gets full rights of the track for world wide usage. <br /><br />Released in partnership with Potluck Labs and the Jukebox Collective in 2022.</div>
								<div className='informations'>
									<span className='nftCount'><b>Owned</b>: {ownedCount}</span>
									<span className='nftCount'><b>Price</b>: {ethers.utils.formatEther(price)}FTM</span>
									<span className='nftCount'><b>Credits</b>: {credits}</span>
								</div>
								<div className='buttons'>
									{connectWalletButton()}
									<div className='buttonCluster'>
										{amountButtons()}
									</div>
									{mintButton()}
								</div>
								<div className='buttons'>
									{stemButton()}
								</div>
							</div>
						</div>
					</div>
				</div>
				<span className='darkCard h1'>{minted} NFTs in circulation</span>
				<ToastContainer toastClassName='toaster' />
			</header>
		</div>
	);
}

export default App;
